import { useTheme } from 'styled-components';
import React from 'react';
import { Text, Heading } from '@miro-site/core';
import { jsx as _jsx } from "react/jsx-runtime";

var SuperText = function SuperText(_ref) {
  var color = _ref.color,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'p0' : _ref$variant,
      children = _ref.children,
      as = _ref.as;
  var theme = useTheme();
  var colors = theme.colors;

  if (variant == 'p0' || variant == 'p1' || variant == 'p1medium' || variant == 'p2') {
    return /*#__PURE__*/_jsx(Text, {
      as: as,
      $variant: variant,
      $styles: {
        color: colors[color] || color,
        whiteSpace: 'pre-wrap'
      },
      dangerouslySetInnerHTML: {
        __html: children
      } // ! html is escaped in TextEditor

    });
  }

  return /*#__PURE__*/_jsx(Heading, {
    as: as,
    $variant: variant,
    $styles: {
      color: colors[color] || color,
      whiteSpace: 'pre-wrap'
    },
    dangerouslySetInnerHTML: {
      __html: children
    } // ! html is escaped in TextEditor

  });
};

export default SuperText;